import React from 'react'

// Just use the default span props, since the pill is basically a decorated span
export type PillProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> & { children: React.ReactNode }

/**
 * A pill shaped span, based on the cms design system badge component with
 * our own default styles
 *
 * @param props
 * @returns
 */
export const Pill: React.FC<PillProps> = ({ children, className, ...otherProps }) => (
  <span
    className={`
      my-c-pill
      ds-c-badge
      ds-u-text-align--center
      ds-u-color--base
      ${className ?? ''}
    `}
    {...otherProps}
  >
    {children}
  </span>
)
